import { defineEndpoint } from './defineEndpoint';
import {
    type DefineEndpointOptions,
    type DefineMutationEndpointFnReturn,
    type DefineQueryEndpointFnReturn,
    type EndpointConfig,
    type Methods,
    type ServiceTree,
    type StatusCode,
} from './types';
import type z from 'zod';

export const defineService = <T extends ServiceTree<unknown>>(
    builder: (
        defineEndpoint: <
            Method extends Methods,
            Path extends `/${string}`,
            Query extends z.ZodObject | undefined,
            Headers extends z.ZodObject | undefined,
            Body extends z.ZodType | undefined,
            Responses extends Partial<Record<StatusCode, z.ZodType>>,
        >(
            config: EndpointConfig<Method, Path, Query, Headers, Body, Responses>,
        ) => Method extends 'GET' | 'HEAD'
            ? DefineQueryEndpointFnReturn<Method, Path, Query, Headers, Body, Responses>
            : Method extends 'POST' | 'PATCH' | 'PUT' | 'DELETE'
              ? DefineMutationEndpointFnReturn<Method, Path, Query, Headers, Body, Responses>
              : never,
    ) => T,
    options: DefineEndpointOptions,
): T => builder((config) => defineEndpoint(config, options));
